import { ServiceApi } from '../../utils/auth'

const state = {
    peromotions: [],
    loading: false,
    error: null,
    stats: []
}

const actions = {
    async fetchPromotions({ commit }, payload) {
        commit('promotionsBegin')
        try {
            const resp = await ServiceApi.get(`/api/advertising`, payload);
            commit('promotionsSuccess', true)
            commit("SET_PROMOTIONS", resp.data);
            return resp.data;
        } catch (error) {
            commit('promotionsErr', error)
            return error
        }
    },
    async pausePromotion({ commit }, payload) {
        commit("config/SET_OVERLAY", true, { root: true });
        try {
            const resp = await ServiceApi.post(`/api/toggle-pause-advertising`, payload);
            commit('promotionsSuccess', true)
            return resp.data;
        } catch (error) {
            commit('promotionsErr', error)
            return error
        } finally {
            commit("config/SET_OVERLAY", false, { root: true });
        }
    },

    async fetchPromotionsStats({ commit }, id) {
        commit('promotionsBegin')
        try {
            const resp = await ServiceApi.get(`/api/get-service-stats/${id}`);
            commit('promotionsSuccess', true)
            commit("SET_PROMOTIONS_STATS", resp.data);
            return resp.data;
        } catch (error) {
            commit('promotionsErr', error)
            return error
        }
    },
}

const getters = {
    getPromotions: state => state.promotions,
    getPromotionsStats: state => state.stats,
    promotionsLoading: (state) => state.loading,
}

const mutations = {
    SET_PROMOTIONS(state, payload) {
        state.settings = payload.data
    },
    SET_PROMOTIONS_STATS(state, payload){
        state.stats = payload.data
    },
    promotionsBegin(state) {
        state.loading = true
    },
    promotionsSuccess(state) {
        state.loading = false
    },
    promotionsErr(state, err) {
        state.loading = false
        state.error = err
    },
}

export default {
    namespaced: false,
    state,
    actions,
    mutations,
    getters
}
